module.exports = "/_next/static/media/b172a45448e8ea38e12f911f09353967.svg";